import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

export function useAntiPiracy() {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/settings").then(r => {
      setEnabled(r.data?.anti_piracy_enabled === true);
    }).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const isStudent = user?.role === "user";
  const shouldProtect = loaded && enabled && isStudent;

  return { shouldProtect, isStudent, enabled, loaded, user };
}

export function useMovingWatermark(user, courseId) {
  const [pos, setPos] = useState({ top: 10, left: 10 });
  const intervalRef = useRef(null);

  const watermarkText = user
    ? `${user.name || ""} | ${user.phone || user.email || ""} | ${courseId || ""} | ${new Date().toLocaleString("en-IN")}`
    : "";

  useEffect(() => {
    const move = () => {
      setPos({
        top: 5 + Math.random() * 70,
        left: 5 + Math.random() * 50,
      });
    };
    move();
    const delay = 8000 + Math.random() * 7000;
    intervalRef.current = setInterval(move, delay);
    return () => clearInterval(intervalRef.current);
  }, []);

  return { pos, watermarkText };
}

export function useKeyboardBlock(active) {
  useEffect(() => {
    if (!active) return;
    const handler = (e) => {
      if (e.key === "PrintScreen" || e.key === "Snapshot") {
        e.preventDefault();
        navigator.clipboard?.writeText?.("");
        return false;
      }
      if (e.ctrlKey && (e.key === "s" || e.key === "S" || e.key === "p" || e.key === "P" || e.key === "c" || e.key === "C" || e.key === "u" || e.key === "U")) {
        e.preventDefault();
        return false;
      }
      if (e.metaKey && (e.key === "s" || e.key === "S" || e.key === "p" || e.key === "P" || e.key === "c" || e.key === "C")) {
        e.preventDefault();
        return false;
      }
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [active]);
}

export function useVisibilityPause(active, videoRef) {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!active) return;
    const handler = () => {
      if (document.hidden && videoRef?.current && !videoRef.current.paused) {
        videoRef.current.pause();
        setShowWarning(true);
        setTimeout(() => setShowWarning(false), 5000);
      }
    };
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, [active, videoRef]);

  return { showWarning, setShowWarning };
}
